import { Outlet } from "react-router";

const MembershipExtensionIndexPage = () => {
  return (
    <>
      <Outlet />
    </>
  );
};
export default MembershipExtensionIndexPage;
